module.exports = __webpack_public_path__ + "media/application/images/demo/content_9-545aa6b604d28e6e01eb10d764770c52.jpg";